import { FeatureFlags } from 'utils/featureFlags';
import useFeatureFlag from './useFeatureFlag';

export function useCrmPricingGroupRowFlag(): boolean {
  const flags = useFeatureFlag([FeatureFlags.crmPricingGroupRow, FeatureFlags.crmPricingEmbed]);
  return flags[FeatureFlags.crmPricingGroupRow] === true && flags[FeatureFlags.crmPricingEmbed] === true;
}
